/**
 * Check validation before submit
 * @param {string} formClass Class of the form to be validated
 * @returns {boolean}
 */
export default (formClass) => {
	let isValid = true;
	Array.from(document.querySelectorAll(`.${formClass} select, .${formClass} input, .${formClass} div, .${formClass} iframe`)).forEach((element) => {
		if (element.offsetParent !== null) {
			element.focus();
			element.blur();
			const formLine = element.closest('.formLine');
			if (formLine && formLine.__vue__.hasError || element.className.includes('-validationError')) {
				isValid = false;
			}
		}
	});
	return isValid;
};
